function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .aj {\n                fill: #c24d4d;\n                opacity: 0;\n            }\n\n            .bj {\n                fill: none;\n                stroke: #000;\n                stroke-linecap: round;\n                stroke-linejoin: round;\n            }\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-294.154 -71.492)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "aj",
  width: 11.6,
  height: 11.6,
  transform: "translate(294.154 71.492)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(296.586 72)"
}, /*#__PURE__*/React.createElement("path", {
  className: "bj",
  d: "M14.943,1.5A1.443,1.443,0,0,0,13.5,2.943V6.792a1.443,1.443,0,1,0,2.886,0V2.943A1.443,1.443,0,0,0,14.943,1.5Z",
  transform: "translate(-11.576 -1.5)"
}), /*#__PURE__*/React.createElement("path", {
  className: "bj",
  d: "M14.235,15v.962a3.367,3.367,0,1,1-6.735,0V15",
  transform: "translate(-7.5 -10.67)"
}), /*#__PURE__*/React.createElement("path", {
  className: "bj",
  d: "M18,28.5v1.924",
  transform: "translate(-14.633 -19.841)"
}), /*#__PURE__*/React.createElement("path", {
  className: "bj",
  d: "M12,34.5h3.849",
  transform: "translate(-10.557 -23.917)"
})));

function SvgMicDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.6,
    height: 11.6,
    viewBox: "0 0 11.6 11.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicDark);
export default __webpack_public_path__ + "static/media/mic_dark.42a15afd.svg";
export { ForwardRef as ReactComponent };